var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('span',{class:_vm.$style.tooltipContent},[_vm._v("\n    "+_vm._s(_vm.$t('views.game.pause_tooltip'))+"\n  ")]),_c('span',{class:_vm.$style.arrow})])}
var staticRenderFns = []

export { render, staticRenderFns }